export const ImpostazioniComponent: ng.IComponentOptions = {
    template: require('./impostazioni.html')
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/impostazioni/impostazioni.ts